import React, { useState } from "react";

import EmailForNewPassword from "./EmailForNewPassword";
//Custom Components
import OTPVerify from "./OTPVerify";
import SetNewPassword from "./SetNewPassword";
import VerifyMFA from "./VerifyMFA";

const NewPassword = (props) => {
    const { reset = false } = props || {};
    const searchParams = new URLSearchParams(window.location?.search);
    const email = searchParams.get('email');

    const [userEmail, setUserEmail] = useState(false);
    const [otpVerified, setOTPVerified] = useState(false);
    const [mfaStatus, setMfaStatus] = useState(false);

    return <>
        {(!userEmail && !otpVerified && !mfaStatus) && <EmailForNewPassword urlEmail={email} setUserEmail={setUserEmail} reset={reset} setMfaStatus={setMfaStatus} />}
        {(userEmail && !otpVerified && !mfaStatus) && <OTPVerify urlEmail={email} email={userEmail}  setUserEmail={setUserEmail} setMfaStatus={setMfaStatus} setOTPVerified={setOTPVerified} reset={reset} />}
        {(!otpVerified && mfaStatus) && <VerifyMFA email={userEmail} setOTPVerified={setOTPVerified} />}
        {(otpVerified) && <SetNewPassword email={userEmail} reset={reset} />}
    </>;
};

export default NewPassword;
